import "./Loading.css";
import {ImEarth} from 'react-icons/im'; 
export default function Loading(){
  return(
    <div className="loading-wrapper">
      <h1>Welcome...</h1>
      <ImEarth  className="loading-icon"/>

    </div>
  )

}